import { RootAction } from "../../Actions/RootAction";

const initialState = {
    loading: false
}

const clientRequest = (state = initialState, action) => {
    switch (action.type) {
        case RootAction.ClientRequest.BeforeRequest:
            return {
                ...state,
                loading: true
            }
        case RootAction.ClientRequest.AfterRequest:
            return {
                ...state,
                loading: false
            }
        default:
            break;
    }

    return state;
}

export default clientRequest;